import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFontStyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFontStyle"><Path fillRule="evenodd" clipRule="evenodd" d="M19.4639 19H21V21H13.5V19H15.2578L13.9551 15H8.15625L6.85449 19H8.5V21H3.5V19H4.75L9.95898 3H14.2539L19.4639 19ZM8.80762 13H13.3037L11.0557 6.09473L8.80762 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFontStyle;
